<template>
	<div>
		<div v-if="params.source == 'edit'" class="d-flex text-left">			
			<div v-for="(name, index) in params.data.dropbox_detail" :key="index" class="filename-wrap mr-2">
					<a :href="params.data.dropbox_detail[index].dropbox_link" target="_blank" class='cellAgtName'>{{ params.data.dropbox_detail[index].filename}}</a> {{ (index < params.data.dropbox_detail.length - 1  || params.data.temp_filename)? ',' : '' }}            
			</div>
			<p @click="openAgreementInNewTab(params.data.temp_filename)" id="agreement-container"><u class="cursor-pointer">{{ params.data.original_filename }}</u></p>
		</div>
		<div v-else class="d-flex text-center">
			<p @click="openAgreementInNewTab(params.data.temp_filename)" id="agreement-container"><u class="cursor-pointer">{{ params.data.original_filename }}</u></p>
		</div>			
	</div>	
</template>

<script>	
	export default {
		name: 'CellRendererAgreementFile',
		methods: {
			openAgreementInNewTab(agreementFileName) {
				window.open(`${process.env.VUE_APP_API}/storage/agreement_temp/${agreementFileName}`, '_blank');

				// TODO: If we have to open the contents in the new tab
				// this.$axiosSecure.get(`/agreement/file/${agreementFileName}`).then(res => {
				// 	const url= window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf; charset=utf-8' }));
				// 	window.open(url, '_blank');
				// })
				// .catch(error => {
				// 	this.$vs.notify({
        //     color: "danger",
        //     title: "Something went wrong",
        //     text: "Please contact the server admin",
        //   });
				// })
			}
		}
	}
</script>
<style lang="scss">
	.vs-tooltip {
		text-align: center;
	}
</style>